<template>
  <div class="pretty" :class="classes">
    <input
      v-bind="$attrs"
      class="pretty_checkbox"
      type="radio"
      :value="value"
      :checked="modelValue == value"
      @input="$emit('update:modelValue', $event.target.value)"
    />
    <div class="state p-cifra">
      <i
        v-if="esCheckbox"
        class="icon fa fa-check"
      ></i>
      <label class="pretty_checkbox control-label">
        <slot></slot>
      </label>
    </div>
  </div>
</template>

<script>

// No olvidar poner el atributo name para que funcionen los radio
export default {
  props: {
    // Valor cuando este radio está marcado
    value: { type: String, required: true },
    // Valor actual del radio.
    modelValue: { type: String, default: null },
    tipo: {
      type: String,
      default: 'checkbox',
      validator: (value) => ['checkbox', 'switch'].includes(value),
    },
  },
  emits: ['update:modelValue'],
  computed: {
    classes() {
      let clases = '';
      if (this.tipo === 'switch') {
        clases += ' p-switch p-fill';
      } else {
        clases += ' p-icon p-round';
      }
      return clases;
    },
    esCheckbox() {
      return this.tipo === 'checkbox';
    },
  },
};
</script>
